export function unboundCardCopy(
  card: {
    brief?: { request?: string };
    refusal?: { reason?: string };
    questions?: ReadonlyArray<string>;
  },
  canEdit: boolean,
): { headline: string; subtitle?: string; actionLabel?: string } {
  if (card.refusal?.reason) {
    return {
      headline: card.brief?.request?.trim() || "This card isn't ready yet",
      subtitle: canEdit ? card.refusal.reason : "This isn't ready to show yet.",
      actionLabel: canEdit ? 'Edit card' : undefined,
    };
  }
  return {
    headline: 'Data pending',
    subtitle: card.questions?.length ? card.questions.join(' ') : undefined,
    actionLabel: canEdit ? 'Edit card' : undefined,
  };
}
